/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './tabs-extended-media';
import '../tabs-extended/tabs-extended';
import '../content-item-row/content-item-row-media';
import '../content-section/content-section-heading';
